import * as React from "react";
import Paper from "@mui/material/Paper";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import {
  Button,
  Divider,
  Typography,
  AppBar,
  Grow,
  Pagination,
  PaginationItem,
} from "@mui/material";
import {
  DataGrid,
  GridToolbar,
  gridPageCountSelector,
  gridPageSelector,
  useGridApiContext,
  useGridSelector,
} from "@mui/x-data-grid";
import { useSelector } from "react-redux";
import API from "../../Api/api";
import moment from "moment";
import toast from "react-hot-toast";
import { message } from "antd";
const currencyFormatter = new Intl.NumberFormat("en-US", {
  style: "decimal",
});
const currencyFormatter2 = new Intl.NumberFormat("en-US", {
  style: "decimal",
  minimumFractionDigits: 8,
});

const columns = [
  {
    field: "code",
    headerName: "Asset Code",
    minWidth: 250,
  },
  {
    field: "description",
    headerName: "Description",
    minWidth: 170,
    align: "left",
  },
  {
    field: "location",
    headerName: "Location",
    minWidth: 170,
    align: "left",
  },
  {
    field: "sub_location",
    headerName: "Sub-Location",
    minWidth: 170,
    align: "left",
  },
  {
    field: "category",
    headerName: "Category",
    minWidth: 170,
    align: "left",
  },
  {
    field: "purchase_date",
    headerName: "Purchase Date",
    minWidth: 170,
    align: "left",
  },
  {
    field: "exhaustion_date",
    headerName: "Exhaustion Date",
    minWidth: 170,
    align: "left",
  },
  {
    field: "cost",
    headerName: "Cost",
    minWidth: 170,
    align: "left",
    valueFormatter: ({ value }) => currencyFormatter.format(value),
  },
  {
    field: "accum_depre",
    headerName: "Accum. Depn",
    minWidth: 170,
    align: "left",
    valueFormatter: ({ value }) => currencyFormatter.format(value),
  },

  {
    field: "carrying_amount",
    headerName: "Carrying Amt",
    minWidth: 170,
    align: "left",
    valueFormatter: ({ value }) => currencyFormatter.format(value),
  },
  {
    field: "depreciation",
    headerName: "Depreciation",
    minWidth: 170,
    align: "left",
    valueFormatter: ({ value }) => currencyFormatter.format(value),
  },
  {
    field: "daily_depreciation",
    headerName: "Daily Depreciation",
    minWidth: 170,
    align: "left",
    valueFormatter: ({ value }) => currencyFormatter2.format(value),
  },
  {
    field: "days_expired",
    headerName: "Days Expired",
    minWidth: 170,
    align: "left",
    valueFormatter: ({ value }) => currencyFormatter.format(value),
  },
  {
    field: "days_unexpired",
    headerName: "Days Unexpired",
    minWidth: 170,
    align: "left",
    valueFormatter: ({ value }) => currencyFormatter.format(value),
  },
  {
    field: "total_asset_life",
    headerName: "Total Asset Life(Days)",
    minWidth: 170,
    align: "left",
    valueFormatter: ({ value }) => currencyFormatter.format(value),
  },

  {
    field: "purchase_receipt_number",
    headerName: "Purchase receipt No.",
    minWidth: 170,
    align: "left",
  },
  {
    field: "purchase_invoice_number",
    headerName: "Purchase invoice No.",
    minWidth: 170,
    align: "left",
  },
  {
    field: "model_number",
    headerName: "Model Number",
    minWidth: 170,
    align: "left",
  },
  {
    field: "serial_number",
    headerName: "Chassis/Serial Number",
    minWidth: 170,
    align: "left",
  },
  {
    field: "supplier",
    headerName: "Supplier",
    minWidth: 170,
    align: "left",
  },
  {
    field: "status",
    headerName: "Status",
    minWidth: 170,
    align: "left",
  },
  {
    field: "revalued",
    headerName: "Revalued",
    minWidth: 170,
    align: "left",
  },
  {
    field: "impaired",
    headerName: "Impaired",
    minWidth: 170,
    align: "left",
  },
];
function CustomPagination() {
  const apiRef = useGridApiContext();
  const page = useGridSelector(apiRef, gridPageSelector);
  const pageCount = useGridSelector(apiRef, gridPageCountSelector);

  return (
    <Pagination
      color="primary"
      sx={{ bgcolor: "#ffffff" }}
      variant="outlined"
      shape="rounded"
      page={page + 1}
      count={pageCount}
      // @ts-expect-error
      renderItem={(props2) => <PaginationItem {...props2} disableRipple />}
      onChange={(event, value) => apiRef.current.setPage(value - 1)}
    />
  );
}
export default function RightOfUseAssetReport() {
  const mode_state = useSelector((state) => state.mode);
  const [mode, setMode] = React.useState(mode_state);
  React.useEffect(() => {
    setMode(mode_state);
  }, [mode_state]);

  const assetsData = useSelector((state) => state.rightOfUse);
  const locationData = useSelector((state) => state.location);
  const [data, setData] = React.useState(assetsData);
  const [filterData, setFilterData] = React.useState({
    location: "",
    category: "",
    depreciation_start: "",
    depreciation_end: "",
    acquisition_start: "",
    acquisition_end: "",
    expiration_start: "",
    expiration_end: "",
  });
  const data2 = filterData.depreciation_start
    ? data.filter(
        (d) =>
          moment(d.exhaustion_date) >= moment(filterData.depreciation_start)
      )
    : data.filter((d) => moment(d.exhaustion_date) >= moment());

  function clearFilter() {
    setFilterData({
      location: "",
      category: "",
      depreciation_start: "",
      depreciation_end: "",
      acquisition_start: "",
      acquisition_end: "",
      expiration_start: "",
      expiration_end: "",
    });
    setData(assetsData);
  }

  const location = filterData.location
    ? `&location=${filterData.location.toLocaleLowerCase()}`
    : "";

  const purchase_date_start = filterData.acquisition_start
    ? `&purchase_date[gte]=${filterData.acquisition_start}`
    : "";
  const purchase_date_end = filterData.acquisition_end
    ? `&purchase_date[lte]=${filterData.acquisition_end}`
    : "";
  const expiration_start = filterData.expiration_start
    ? `&exhaustion_date[gte]=${filterData.expiration_start}`
    : "";
  const expiration_end = filterData.expiration_end
    ? `&exhaustion_date[lte]=${filterData.expiration_end}`
    : "";
  const depreciation_end = filterData.depreciation_end
    ? `&depreciation_end=${filterData.depreciation_end}`
    : "";
  const depreciation_start = filterData.depreciation_start
    ? `&depreciation_start=${filterData.depreciation_start}`
    : "";
  const query = `/api/v1/company-assets/get-asset-by-code/code?disposed[eq]=false&approved[eq]=true&category[eq]=right-of-use asset${location}${purchase_date_end}${purchase_date_start}${expiration_start}${expiration_end}${depreciation_start}${depreciation_end}`;

  // ! A function to fetch queried data from the database//---------start------------
  const fetchAsset = async () => {
    let fetchingId;
    try {
      if (
        !location &&
        !purchase_date_end &&
        !purchase_date_start &&
        !expiration_end &&
        !expiration_start &&
        !depreciation_end &&
        !depreciation_start
      ) {
        toast.error("you can't generate  a report while all fields are empty");
        return;
      }
      if (depreciation_end && !depreciation_start) {
        toast.error(
          "both depreciation end and depreciation start are required"
        );
        return;
      }
      if (!depreciation_end && depreciation_start) {
        toast.error(
          "both depreciation end and depreciation start are required"
        );
        return;
      }
      if (moment(depreciation_end) < moment(depreciation_start)) {
        toast.error(
          "depreciation end date can't be less than depreciation start date"
        );
        return;
      }
      fetchingId = toast.loading("generating report please wait...");
      const res = await API.get(query);
      toast.remove(fetchingId);
      if (res.data.length === 0) {
        message.info("No data was found");
        return;
      }
      if (res.data.length > 0) {
        setData(res.data);
        message.info("Reported successfully generated");
      }
    } catch (error) {
      toast.remove(fetchingId);
      toast.error(error.message);
    }
  };
  // ! -------------function end-----------------------------

  const allCost = data2.reduce((acc, val) => acc + val.cost, 0);
  const allCarryingAmount = data2.reduce(
    (acc, val) => acc + val.carrying_amount,
    0
  );
  const allDepreciation = data2.reduce((acc, val) => acc + val.depreciation, 0);
  const allAccumDepn = data2.reduce((acc, val) => acc + val.accum_depre, 0);
  const handleChangeCategory = (event) => {
    setFilterData({
      ...filterData,
      category: event.target.value,
    });
  };
  const handleChangeLocation = (event) => {
    setFilterData({
      ...filterData,
      location: event.target.value,
    });
  };

  return (
    <div style={{ marginBottom: "40px" }}>
      <div
        elevation={16}
        style={{
          fontSize: "14px",
          marginBottom: "20px",
          display: "flex",
          flexDirection: "row",
          // alignItems: "center",
          justifyContent: "space-between",
          height: "95px",
        }}
      >
        <div style={{ display: "flex", flexDirection: "column", rowGap: 9 }}>
          <FormControl size="small" sx={{ m: 1, width: 140 }}>
            <InputLabel
              style={{ color: `${mode === "dark" ? "#0883FF" : "#116149"}` }}
              id="demo-simple-select-standard-label"
            >
              Location
            </InputLabel>
            <Select
              style={{ backgroundColor: "#ccc" }}
              labelId="demo-simple-select-standard-label"
              id="demo-simple-select-standard"
              value={filterData.location}
              onChange={handleChangeLocation}
              label="Category"
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              {locationData?.map((data) => {
                return (
                  <MenuItem key={data.id} value={data.name}>
                    {data.name}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
          <FormControl size="small" sx={{ m: 1, width: 140 }}>
            <InputLabel
              style={{ color: `${mode === "dark" ? "#0883FF" : "#116149"}` }}
              id="demo-simple-select-standard-label"
            >
              Category
            </InputLabel>
            <Select
              style={{ backgroundColor: "#ccc" }}
              labelId="demo-simple-select-standard-label"
              id="demo-simple-select-standard"
              value={filterData.category}
              onChange={handleChangeCategory}
              disabled
              label="Category"
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>

              <MenuItem value={"right-of-use asset"}>
                RIGHT-OF-USE ASSET
              </MenuItem>
            </Select>
          </FormControl>
        </div>
        <div style={{ display: "flex", flexDirection: "column" }}>
          <label
            style={{
              fontWeight: "bold",
              fontSize: "14px",
              color: `${mode === "dark" ? "#0883FF" : "#116149"}`,
            }}
            htmlFor="start-date"
          >
            Depreciation start
          </label>
          <input
            value={filterData.depreciation_start}
            onChange={(e) =>
              setFilterData({
                ...filterData,
                depreciation_start: e.target.value,
              })
            }
            style={{
              borderRadius: "5px",
              border: "1px solid #3D4F58",
            }}
            id="start-date"
            type="date"
            size={"large"}
            name="start-date"
          />

          <label
            style={{
              fontWeight: "bold",
              fontSize: "14px",
              color: `${mode === "dark" ? "#0883FF" : "#116149"}`,
            }}
            htmlFor="end-date"
          >
            Depreciation end
          </label>
          <input
            value={filterData.depreciation_end}
            onChange={(e) =>
              setFilterData({
                ...filterData,
                depreciation_end: e.target.value,
              })
            }
            style={{
              borderRadius: "5px",
              border: "1px solid #3D4F58",
            }}
            id="end-date"
            type="date"
            size="small"
            name="end-date"
          />
        </div>
        <div style={{ display: "flex", flexDirection: "column" }}>
          <label
            style={{
              fontWeight: "bold",
              fontSize: "14px",
              color: `${mode === "dark" ? "#0883FF" : "#116149"}`,
            }}
            htmlFor="acq-start-date"
          >
            Acquisition start
          </label>
          <input
            value={filterData.acquisition_start}
            onChange={(e) =>
              setFilterData({
                ...filterData,
                acquisition_start: e.target.value,
              })
            }
            style={{
              borderRadius: "5px",
              border: "1px solid #3D4F58",
            }}
            id="acq-start-date"
            type="date"
            size="small"
          />
          <label
            style={{
              fontWeight: "bold",
              fontSize: "14px",
              color: `${mode === "dark" ? "#0883FF" : "#116149"}`,
            }}
            htmlFor="acq-start-date"
          >
            Acquisition end
          </label>
          <input
            value={filterData.acquisition_end}
            onChange={(e) =>
              setFilterData({
                ...filterData,
                acquisition_end: e.target.value,
              })
            }
            style={{
              borderRadius: "5px",
              border: "1px solid #3D4F58",
            }}
            id="acq-end-date"
            type="date"
            size="small"
          />
        </div>
        <div style={{ display: "flex", flexDirection: "column" }}>
          <label
            style={{
              fontWeight: "bold",
              fontSize: "14px",
              color: `${mode === "dark" ? "#0883FF" : "#116149"}`,
            }}
            htmlFor="acq-start-date"
          >
            Expiration start
          </label>
          <input
            value={filterData.expiration_start}
            onChange={(e) =>
              setFilterData({
                ...filterData,
                expiration_start: e.target.value,
              })
            }
            style={{
              borderRadius: "5px",
              border: "1px solid #3D4F58",
            }}
            id="acq-end-date"
            type="date"
            size="small"
          />
          <label
            style={{
              fontWeight: "bold",
              fontSize: "14px",
              color: `${mode === "dark" ? "#0883FF" : "#116149"}`,
            }}
            htmlFor="acq-start-date"
          >
            Expiration end
          </label>
          <input
            value={filterData.expiration_end}
            onChange={(e) =>
              setFilterData({
                ...filterData,
                expiration_end: e.target.value,
              })
            }
            style={{
              borderRadius: "5px",
              border: "1px solid #3D4F58",
            }}
            id="acq-end-date"
            type="date"
            size="small"
          />
        </div>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <Button
          onClick={fetchAsset}
          size="small"
          variant="contained"
          style={{
            backgroundColor: `${mode === "dark" ? "#0883FF" : "#116149"}`,
          }}
        >
          Generate Report
        </Button>
        <Button
          onClick={clearFilter}
          size="small"
          variant="contained"
          style={{ backgroundColor: "#f47373" }}
        >
          Clear Filter
        </Button>
      </div>

      <Divider style={{ marginBottom: "10px" }} />
      <Paper sx={{ width: "100%", height: "55vh" }}>
        <DataGrid
          columns={columns}
          rows={data2}
          density="compact"
          {...data}
          style={{
            backgroundColor: `${mode === "dark" ? "#101418" : "#ffffff"}`,
            color: `${mode === "dark" ? "#fff" : "#000"}`,
          }}
          sx={{
            boxShadow: 2,
            border: 1,
            "& .MuiDataGrid-cell:hover": {
              color: "primary.main",
            },
            "& .MuiDataGrid-footerCell": {
              backgroundColor: "primary.main",
            },
            "& .MuiDataGrid-columnsContainer, .MuiDataGrid-cell": {
              backgroundColor: mode === "light" ? "#fafafa" : "#1d1d1d",
              borderBottom: `1px solid ${
                mode === "light" ? "#f0f0f0" : "#303030"
              }`,
            },
            "& .MuiDataGrid-columnHeader, .MuiDataGrid-cell": {
              borderRight: `1px solid ${
                mode === "light" ? "#f0f0f0" : "#303030"
              }`,
            },
            "& .MuiDataGrid-cell": {
              color:
                mode === "light" ? "rgba(0,0,0,.85)" : "rgba(255,255,255,0.65)",
            },
          }}
          slots={{ toolbar: GridToolbar, pagination: CustomPagination }}
          checkboxSelection
          disableRowSelectionOnClick
        />
        <Grow in timeout={2000}>
          <AppBar
            elevation={0}
            position="fixed"
            style={{
              backgroundColor: `${mode === "dark" ? "#101418" : "#efeded"}`,
              color: "#000000",
              borderTop: "0.5px solid #ccc",
              height: 35,
            }}
            sx={{ top: "auto", bottom: 0 }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-around",
                alignItems: "center",
                alignContent: "center",
                marginLeft: "180px",
                fontWeight: "bold",
                height: 35,
              }}
            >
              <Typography
                style={{
                  backgroundColor: "rgba(255,255,255,0.65)",
                  padding: "2px",
                  border: "0.5px solid #000000",
                  borderRadius: "5px",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  fontSize: "11px",
                }}
                fontWeight={"bold"}
              >
                Cost: {currencyFormatter.format(allCost)}
              </Typography>
              <Typography
                style={{
                  backgroundColor: "rgba(255,255,255,0.65)",
                  padding: "2px",
                  border: "0.5px solid #000000",
                  borderRadius: "5px",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  fontSize: "11px",
                }}
                fontWeight={"bold"}
              >
                Accum. Dpn {currencyFormatter.format(allAccumDepn)}
              </Typography>
              <Typography
                style={{
                  backgroundColor: "rgba(255,255,255,0.65)",
                  padding: "2px",
                  border: "0.5px solid #000000",
                  borderRadius: "5px",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  fontSize: "11px",
                }}
                fontWeight={"bold"}
              >
                Carrying Amnt: {currencyFormatter.format(allCarryingAmount)}
              </Typography>
              <Typography
                style={{
                  backgroundColor: "rgba(255,255,255,0.65)",
                  padding: "2px",
                  border: "0.5px solid #000000",
                  borderRadius: "5px",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  fontSize: "11px",
                }}
                fontWeight={"bold"}
              >
                Depreciation: {currencyFormatter.format(allDepreciation)}
              </Typography>
            </div>
          </AppBar>
        </Grow>
      </Paper>
    </div>
  );
}
